import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';

Sentry.init({
  dsn: "https://d2bca23e92ed4bbfaf6ca7b73e0fb411@o4509282991734784.ingest.us.sentry.io/4509283000188928",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration()
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    console.log('Aplicação iniciada com sucesso');
  })
  .catch(err => {
    console.error('Erro ao iniciar a aplicação:', err);
    Sentry.captureException(err);
  });
